import { Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { SET_DASHBOARD } from '@/store/mutation_types';
import { GET_DASHBOARD } from '@/store/action_types';
import Dashboard, { GetDashboard } from '@/services/dashboard';

// Each load is numbered: switching the period while one is in flight must not
// let the older answer land on top of the newer one.
let dashboardRequestId = 0;

const dashboard: Module<any, {}> = {
  state: {
    dashboard: {
      data: null,
      // The period the data is for, and when it arrived.
      range: null,
      loadedAt: null,
      isLoading: false,
      // The last load failed (the page shows a retry, not empty charts).
      failed: false,
    },
  },
  getters: {
    dashboard: (state: { dashboard: any }) => state.dashboard,
  },
  mutations: {
    [SET_DASHBOARD]: (state: { dashboard: any }, payload: any) => {
      state.dashboard = { ...state.dashboard, ...payload };
    },
  },
  actions: {
    [GET_DASHBOARD]: async ({ commit }: any, payload: GetDashboard) => {
      const requestId = ++dashboardRequestId;
      commit(SET_DASHBOARD, { isLoading: true, failed: false });

      // The API's own errors are already toasted by its interceptor, which
      // then answers with nothing; a request that never got out throws.
      let result: AxiosResponse | undefined;
      try {
        result = await Dashboard.getDashboard(payload);
      } catch (error) {
        result = undefined;
      }

      if (requestId !== dashboardRequestId) return false;

      if (result && result.data && result.data.status) {
        commit(SET_DASHBOARD, {
          data: result.data.data,
          range: payload.range,
          loadedAt: Date.now(),
          isLoading: false,
          failed: false,
        });
        return true;
      }

      commit(SET_DASHBOARD, { isLoading: false, failed: true });
      return false;
    },
  },
};

export default dashboard;
